import * as React from "react";
import { ILookupDictionary } from "../../lookup/types/ILookupDictionary";
import { setDataSource } from "../../redux/reducers/RepertoireReducer";
import { IActiveAccordion } from "../../redux/types/IActiveAccordion";
import IMembersPortalComponentDataItem from "../../redux/types/IMembersPortalComponentDataItem";
import { IResultsPerPage } from "../../redux/types/IResultsPerPage";
import { ITabReduxItem } from "../../redux/types/ITabReduxItem";
import { MemberPortalSearchTypeItem } from "../../redux/types/MemberPortalSearchTypeItem";
import { IAllRegisteredWorkSearchQuery } from "../types/IAllRegisteredWorkSearchQuery";
import { IAllRegisteredWorkSearchResult } from "../types/IAllRegisteredWorkSearchResult";
import MemberWorksPage from "../memberWorks/MemberWorksPage";
import { DataSource } from "../../repertoire/types/DataSource";
import { SEARCH_VIEW_ALL_REGISTERED_WORKS } from "../Consts";
import { IMembersPortalPathInfo } from "../types/IMembersPortalPathInfo";



export interface IAllRegisteredWorksPageProps {
    allRegisteredWorksPageData: IMembersPortalComponentDataItem;
    searchViewData: IMembersPortalComponentDataItem;
    searchResultsTableData: IMembersPortalComponentDataItem;
    searchAllRegisteredWorks?: (query: IAllRegisteredWorkSearchQuery) => void;
    allRegisteredWorkSearchResults: IAllRegisteredWorkSearchResult[];
    searchSuccessful: boolean;
    registeredWorksMaintenanceGeneralDataViewData: IMembersPortalComponentDataItem;
    lookupValues: ILookupDictionary;
    loadMembersPortalFromPath: (pathInfo: IMembersPortalPathInfo, currentUserNameNumber: string, location: Location) => void;
    indexOfFirstResult?: number;
    indexOfLastResult?: number;
    resultsPerPage?: number;
    currentPage?: number;
    resetPagination: (repertoireSection: string) => void;
    updatePagination: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => void;
    getAllRegisteredWorkDetails: (dataSource: string, workID: number, lookupValues: ILookupDictionary, memberWorkMaintenanceDataViewData: IMembersPortalComponentDataItem) => void;
    addNewDraftWorks: (lookups: ILookupDictionary, currentUserNameNumber?: string, isNew?: boolean, registeredWorksMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem) => void;
    sortSearchResults: (name: string, results: any) => void;
    defaultActiveAccordions?: IActiveAccordion[];
    allResultsPerPage?: IResultsPerPage[];
    updateUserPreferences: (allResultsPerPage: IResultsPerPage[], activeAccordions: IActiveAccordion[], newActiveAccordionName?: string, accordionExpanded?: boolean, componentName?: string, indexOfFirstResult?: number, indexOfLastResult?: number, resultsPerPage?: number, repertoireSection?: string) => void;
    disabled?: boolean;
    roles?: string[];
    saveRoles?: (roles: string[]) => void;
    setDataSource: typeof setDataSource;
    dataSource: string;
    activeTab?: number;
    tabs?: ITabReduxItem[];
    memberPortalSearchType: MemberPortalSearchTypeItem;
    expandWorkResult?: (workResult: number) => void;
    expandedWorkResults?: number[];
    expandAllResults: () => void;
    expandAll: boolean;
    currentUserNameNumber?: string;
    customer?: string;
}

const AllRegisteredWorksPage = (props: IAllRegisteredWorksPageProps) => {

    const currentDataSource = DataSource.Repertoire;
    
    React.useEffect(() => {
        if (props.dataSource !== currentDataSource) {
        props.setDataSource(currentDataSource);
        }
    }, [props.dataSource]);
	
    return (
        <MemberWorksPage 
            memberWorksPageData={ props.allRegisteredWorksPageData}
            searchViewData={ props.searchViewData}
            searchResultsTableData={ props.searchResultsTableData}
            searchDraftWorks={ props.searchAllRegisteredWorks}
            memberWorkSearchResults={ props.allRegisteredWorkSearchResults}
            searchSuccessful={ props.searchSuccessful}
            memberWorksMaintenanceGeneralDataViewData={ props.registeredWorksMaintenanceGeneralDataViewData}
            lookupValues={ props.lookupValues}
            indexOfFirstResult={ props.indexOfFirstResult}
            indexOfLastResult={ props.indexOfLastResult}
            resultsPerPage={ props.resultsPerPage}
            currentPage={ props.currentPage}
            resetPagination={ props.resetPagination}
            updatePagination={ props.updatePagination}
            getMemberWorkDetails={ props.getAllRegisteredWorkDetails}
            addNewDraftWorks={ props.addNewDraftWorks}
            sortSearchResults={ props.sortSearchResults}
            defaultActiveAccordions={ props.defaultActiveAccordions}
            allResultsPerPage={ props.allResultsPerPage}
            updateUserPreferences={props.updateUserPreferences}
            loadMembersPortalFromPath={props.loadMembersPortalFromPath}
            disabled={ props.disabled}
            roles={ props.roles}
            saveRoles={ props.saveRoles}
            setDataSource={ props.setDataSource}
            dataSource={ currentDataSource }
            activeTab={ props.activeTab}
            tabs={ props.tabs}
            memberPortalSearchType={ props.memberPortalSearchType}
            expandWorkResult={ props.expandWorkResult}
            expandedWorkResults={ props.expandedWorkResults}
            expandAllResults={ props.expandAllResults}
            expandAll={ props.expandAll}
            currentUserNameNumber={ props.currentUserNameNumber}
            componentInstance= {SEARCH_VIEW_ALL_REGISTERED_WORKS}
            customer={props.customer}
        />
    );
}

export default AllRegisteredWorksPage;
